import React, { useMemo } from 'react'
import type { PixelRows } from './pixelType'

/** The plates' lettering ink. */
export const BK_INK = '#7C2714'

/**
 * Block art as one SVG path: every '#' is a square `block` pixels wide, with
 * crisp edges so the squares stay squares at any scale the shell applies.
 */
const BkPixel: React.FC<{
  rows: PixelRows
  block: number
  color?: string
  className?: string
}> = ({ rows, block, color = BK_INK, className }) => {
  const d = useMemo(
    () =>
      rows
        .flatMap((line, y) =>
          [...line].map((c, x) => (c === '#' ? `M${x} ${y}h1v1h-1z` : '')).filter(Boolean)
        )
        .join(''),
    [rows]
  )
  const cols = rows[0]?.length ?? 0
  return (
    <svg
      width={cols * block}
      height={rows.length * block}
      viewBox={`0 0 ${cols} ${rows.length}`}
      shapeRendering="crispEdges"
      className={className}
      aria-hidden
    >
      <path d={d} fill={color} />
    </svg>
  )
}

export default BkPixel
